import PropTypes from 'prop-types';

import { Grid } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../Forms/GenericFormContainer';

import { lengthValidation60, required, validatePassword } from '../Forms/utils';
import { validateSetPassword } from './utils';

import { STYLED_PASSWORD, STYLED_TEXT } from '../Forms/fieldTypes';

const SetPasswordComponent = (props) => {
  const { t } = useTransl();
  const { form, onSubmit, initialValues, onLoad, onUnmount } = props;

  const formData = [
    {
      keyName: 'password',
      label: t('title.password'),
      fieldType: STYLED_PASSWORD,
      autoComplete: 'off',
      validate: [required, validatePassword, lengthValidation60],
      showPasswordRequirements: true,
    },
    {
      keyName: 'confirmPassword',
      label: t('title.confirmPassword'),
      fieldType: STYLED_PASSWORD,
      autoComplete: 'off',
      validate: [required, validatePassword, lengthValidation60],
    },
    {
      keyName: 'token',
      label: t('title.token'),
      fieldType: STYLED_TEXT,
      validate: [],
      isHidden: true,
    },
    {
      keyName: 'uid',
      label: t('title.userId'),
      fieldType: STYLED_TEXT,
      validate: [],
      isHidden: true,
    },
  ];

  return (
    <Grid container justifyContent="center" alignContent="center" flexGrow={1}>
      <Grid item xs={10} sm={8} md={6}>
        <GenericFormContainer
          form={form}
          formData={formData}
          onSubmit={onSubmit}
          initialValues={initialValues}
          onLoad={onLoad}
          onUnmount={onUnmount}
          canBeUpdated={false}
          title={t('actions.setPassword')}
          submitText={t('actions.setPassword')}
          backButton={false}
          validate={validateSetPassword}
          isCentered
        />
      </Grid>
    </Grid>
  );
};

SetPasswordComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  onLoad: PropTypes.func.isRequired,
  onUnmount: PropTypes.func.isRequired,
};

export default SetPasswordComponent;
